/**
 * Discards a lookup result whose email is no longer the one being typed.
 *
 * The query is debounced, so a resolved match can arrive for a previous value. Comparing the two
 * emails is what stops a stale match being attributed to the current input.
 */
export const getCurrentProfileLookupMatch = <T>(
  normalizedEmail: string,
  debouncedEmail: string,
  matchedUser: T | null,
): T | null => (normalizedEmail === debouncedEmail ? matchedUser : null);
